// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__36Lo6","loader":"Loader_loader__21nCC","loadingio":"Loader_loadingio__2t8Ie"};